import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import "./index.scss";
import "../styles/layout-overide.css";
import construction from "./construction.gif";
import emma from "./emma.jpg";

import Media from "react-media";

const Header = () => (
  <div
    style={{
      background: "#f5f5f5",
      marginBottom: "3rem",
      borderBottom: "2px solid #e6e6e6"
    }}
  >
    <div
      style={{
        margin: "0 auto",
        maxWidth: 980,
        padding: "1.45rem 1.0875rem"
      }}
    >
      <h1 style={{ margin: 0, textAlign: "left", fontSize: "2rem" }}>
        <Link
          to="/"
          style={{
            color: "black",
            textDecoration: "none",
            fontSize: "3rem"
          }}
        >
          Just Recipes. No bullshit.
        </Link>
      </h1>
    </div>
  </div>
);

const Sidebar = props => (
  <div
    style={{
      border: "2px solid #e6e6e6",
      maxWidth: 1060,
      padding: "0.5rem",
      marginBottom: "25px",
      marginLeft: "50px"
    }}
  >
    <strong>{props.title}.</strong>
    <img src={props.img}/>
    {props.description}
  </div>
);

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Just Recipes"
      meta={[
        { name: "description", content: "Just Recipes. No bullshit." },
        { name: "keywords", content: "recipes, food, vegetarian, backpacking" }
      ]}
    />
    <Header />
    <div
      style={{
        margin: "0 auto",
        maxWidth: 980,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        height: "100%"
      }}
    >
      <Media query={{ maxWidth: 980 }}>
        {matches =>
          matches ? (
            <div
              style={{
                margin: "0 auto",
                maxWidth: 980,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height: "100%",
                padding: "25px"
              }}
            >
              <div style={{ flex: 1 }}>{children()}</div>
            </div>
          ) : (
            <div
              style={{
                margin: "0 auto",
                maxWidth: 980,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height: "100%",
                padding: "25px"
              }}
            >
              <div style={{ flex: 2.5, paddingRight: "30px" }}>
                {children()}
              </div>

              <div style={{ flex: 1 }}>
                {/*<Sidebar*/}
                  {/*title="About Just Recipes"*/}
                  {/*description="Yet another food blog, but this time just recipes. No bullshit."*/}
                {/*/>*/}
                {/*<Sidebar*/}
                  {/*title="About the author"*/}
                  {/*img={emma}*/}
                  {/*description="Emma Strubell is a PhD student who loves cooking and eating good food. Mostly pescatarian. Trying to be healthy."*/}
                {/*/>*/}
              </div>
            </div>
          )
        }
      </Media>
    </div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;


// WEBPACK FOOTER //
// ./src/layouts/index.js